const getPreviousPageData = () => {
    const previousPage = sessionStorage.getItem('previousPage');
    return previousPage
        ? JSON.parse(previousPage)
        : {
            url: '',
            path: '',
            pageTitle: '',
            pageName: '',
            mainCategory: '',
            categoryTree: '',
        };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const storePageData = (pageData) => {
    sessionStorage.setItem('previousPage', JSON.stringify({
        url: pageData.url,
        path: pageData.path,
        pageTitle: pageData.pageTitle,
        pageName: pageData.pageName,
        mainCategory: pageData.mainCategory,
        categoryTree: pageData.categoryTree,
    }));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAllAssets = (data) => {
    const result = [];
    function findRecursive(items) {
        var _a, _b, _c;
        if (Array.isArray(items)) {
            items.forEach(findRecursive);
        }
        else if (typeof items === 'object' && items !== null) {
            if (items.component === 'roche-video-player') {
                const type = getFileExtension(items.youtube_video || '');
                const name = ((_a = items.preview) === null || _a === void 0 ? void 0 : _a.name) || '';
                if (type || name) {
                    result.push({ type, name });
                }
            }
            if (items.component === 'roche-download-teaser') {
                const type = getFileExtension(((_b = items === null || items === void 0 ? void 0 : items.internal_asset) === null || _b === void 0 ? void 0 : _b.filename) || '');
                const name = ((_c = items === null || items === void 0 ? void 0 : items.internal_asset) === null || _c === void 0 ? void 0 : _c.name) || '';
                if (type || name) {
                    result.push({ type, name });
                }
            }
            if (items.tagName === 'iframe' && items['data-type'] === 'audio') {
                result.push({ type: 'audio', name: '' });
            }
            // Recursively check nested properties
            Object.values(items).forEach(findRecursive);
        }
    }
    findRecursive(data);
    return result;
};
// Helper function to extract the file extension
const getFileExtension = (filename) => {
    var _a;
    if (typeof filename === 'string') {
        return ((_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    }
    return ''; // Return an empty string if filename is not valid
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const page = (data) => {
    var _a, _b, _c, _d;
    const { story } = data;
    const previousPage = getPreviousPageData();
    const pageData = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (data.scrolled && { scrolled: data.scrolled })), (data.error && { error: data.error })), (data.errorType && { errorType: data.errorType })), { siteName: ((_a = data.websiteName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '', sysEnv: process.env.GATSBY_WEBSITE_STAGE || '', market: process.env.GATSBY_ROCHE_TOP_LEVEL_DOMAIN.toUpperCase() || '', language: (story === null || story === void 0 ? void 0 : story.lang) || (data === null || data === void 0 ? void 0 : data.locale) || '', url: window.location.href, domain: window.location.host, path: window.location.pathname, pageTitle: ((_b = story === null || story === void 0 ? void 0 : story.content.meta_tags) === null || _b === void 0 ? void 0 : _b.title) || document.title || '', pageName: (story === null || story === void 0 ? void 0 : story.name) || '', uuid: (story === null || story === void 0 ? void 0 : story.uuid) || '', protected: 'public', referrer: document.referrer, mainCategory: '', categoryTree: ((_c = data === null || data === void 0 ? void 0 : data.breadcrumbs) === null || _c === void 0 ? void 0 : _c.map((item) => item.name).join('|')) || '', previousPage }), (!data.scrolled && { media: getAllAssets((_d = story === null || story === void 0 ? void 0 : story.content) === null || _d === void 0 ? void 0 : _d.body) }));
    storePageData(pageData);
    return pageData;
};

const consent = () => {
    var _a, _b, _c, _d;
    return ({
        C0001: ((_a = window.OptanonActiveGroups) === null || _a === void 0 ? void 0 : _a.includes('C0001')) || true,
        C0002: ((_b = window.OptanonActiveGroups) === null || _b === void 0 ? void 0 : _b.includes('C0002')) || false,
        C0003: ((_c = window.OptanonActiveGroups) === null || _c === void 0 ? void 0 : _c.includes('C0003')) || false,
        C0004: ((_d = window.OptanonActiveGroups) === null || _d === void 0 ? void 0 : _d.includes('C0004')) || false,
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pageContent = (data) => {
    var _a;
    const { story } = data;
    const storyTags = ((_a = story === null || story === void 0 ? void 0 : story.content) === null || _a === void 0 ? void 0 : _a.tag) || [];
    const contentTags = storyTags.map((tag) => ({
        id: '',
        name: tag,
    }));
    return {
        vvpm: [],
        indication: [
            {
                id: '',
                name: '',
            },
        ],
        therapeuticArea: [
            {
                id: '',
                name: '',
            },
        ],
        product: [
            {
                id: '',
                name: '',
            },
        ],
        contentTags: [
            contentTags,
        ],
        contentHashtags: [],
        contentDuration: '',
        course: {
            id: '',
            name: '',
            module: '',
            category: '',
        },
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onsiteSearchData = (data) => {
    var _a;
    return (Object.assign(Object.assign({ term: (data === null || data === void 0 ? void 0 : data.term) || '', results: data[(_a = data === null || data === void 0 ? void 0 : data.filter) === null || _a === void 0 ? void 0 : _a.filter] || (data === null || data === void 0 ? void 0 : data.results) || '' }, ((data === null || data === void 0 ? void 0 : data.resultsPosition) && { resultPosition: data === null || data === void 0 ? void 0 : data.resultsPosition })), { filter: (data === null || data === void 0 ? void 0 : data.filter) || '', searchComponent: (data === null || data === void 0 ? void 0 : data.searchComponent) || '' }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoStartData = (data) => ({
    name: data.name,
    url: data.url,
    provider: data.provider,
    durationTotal: data.durationTotal,
    autoplay: data.autoplay,
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoCompleteData = (data) => ({
    name: data.name,
    url: data.url,
    provider: data.provider,
    durationTotal: data.durationTotal,
    progress: data.progress,
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoProgressData = (data) => ({
    name: data.name,
    url: data.url,
    provider: data.provider,
    durationTotal: data.durationTotal,
    progress: data.progress,
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoErrorData = (data) => ({
    name: data.name,
    url: data.url,
    provider: data.provider,
    durationTotal: data.durationTotal,
    error: data === null || data === void 0 ? void 0 : data.error,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formStartData = (data) => ({
    name: data.name,
    type: data.type,
    step: '',
    stepsTotal: '',
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formSuccessData = (data) => ({
    name: data.name,
    type: data.type,
    step: '',
    stepsTotal: '',
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formErrorData = (data) => ({
    name: data.name,
    type: data.type,
    step: '',
    stepsTotal: '',
    error: data.error,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onsiteSearchClickData = (data) => ({
    url: (data === null || data === void 0 ? void 0 : data.url) || '',
    domain: (data === null || data === void 0 ? void 0 : data.domain) || '',
    path: (data === null || data === void 0 ? void 0 : data.path) || '',
    innerText: (data === null || data === void 0 ? void 0 : data.innerText) || '',
    position: (data === null || data === void 0 ? void 0 : data.position) || '',
    name: (data === null || data === void 0 ? void 0 : data.name) || '',
    type: 'Search Result',
});

const consentUpdate = () => ({
    event: 'consentUpdate',
    timestamp: Math.floor(Date.now() / 1000),
    user: {
        consent: consent(),
    },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultPageView = (data) => ({
    event: 'defaultPageView',
    timestamp: Math.floor(Date.now() / 1000),
    page: page(data),
    consent: {
        user: consent(),
    },
    content: pageContent(data),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const scroll = (data) => ({
    event: 'scroll',
    timestamp: Math.floor(Date.now() / 1000),
    page: page(data),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pageError = (data) => {
    const updatedData = Object.assign(Object.assign({}, data), { error: data.story.slug, errorType: `Error ${data.story.slug}` });
    return ({
        event: 'pageError',
        timestamp: Math.floor(Date.now() / 1000),
        page: page(updatedData),
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultLinkClick = (data) => {
    var _a, _b, _c, _d;
    let domain = '';
    let path = '';
    let fullUrl = '';
    try {
        // Check if data.url is a full URL or a relative path
        if (data.url.startsWith('http') || data.url.startsWith('//')) {
            // It's already a full URL, so we can use it directly
            const urlObj = new URL(data.url);
            domain = urlObj.hostname.replace('www.', '');
            path = urlObj.pathname;
            fullUrl = data.url; // Use the original full URL as it is
        }
        else {
            // Handle relative pathing for URLs on the same domain
            const currentDomain = window.location.origin;
            const fullPath = new URL(data.url, currentDomain).href; // Resolves relative URL
            const urlObj = new URL(fullPath);
            domain = urlObj.hostname.replace('www.', '');
            path = urlObj.pathname;
            fullUrl = fullPath; // Now we have the full URL with the current domain
        }
    }
    catch (e) {
        // If something fails, fallback to the provided URL
        fullUrl = data.url;
        path = data.url;
    }
    return {
        event: 'defaultLinkClick',
        timestamp: Math.floor(Date.now() / 1000),
        link: {
            url: fullUrl, // Use the full URL, whether it's external or relative
            domain,
            path,
            innerText: (_a = data === null || data === void 0 ? void 0 : data.innerText) === null || _a === void 0 ? void 0 : _a.trimStart(),
            position: data === null || data === void 0 ? void 0 : data.position,
            name: ((_b = data === null || data === void 0 ? void 0 : data.name) === null || _b === void 0 ? void 0 : _b.trimStart()) || ((_c = data === null || data === void 0 ? void 0 : data.innerText) === null || _c === void 0 ? void 0 : _c.trimStart()),
            type: data === null || data === void 0 ? void 0 : data.type,
            socialMedia: (_d = data === null || data === void 0 ? void 0 : data.socialMedia) === null || _d === void 0 ? void 0 : _d.trimStart(),
            socialInteraction: data === null || data === void 0 ? void 0 : data.socialInteraction,
        },
        components: {
            bookmark: {
                items: [],
            },
        },
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onsiteSearch = (data) => ({
    event: 'onsiteSearch',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        onsiteSearch: onsiteSearchData(data),
    },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoStart = (data) => ({
    event: 'videoStart',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        video: videoStartData(data),
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoComplete = (data) => ({
    event: 'videoComplete',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        video: videoCompleteData(data),
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoProgress = (data) => ({
    event: 'videoProgress',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        video: videoProgressData(data),
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const videoError = (data) => ({
    event: 'videoError',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        video: videoErrorData(data),
    },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formStart = (data) => ({
    event: 'formStart',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        form: formStartData(data),
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formSuccess = (data) => ({
    event: 'formSuccess',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        form: formSuccessData(data),
    },
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formError = (data) => ({
    event: 'formError',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        form: formErrorData(data),
    },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onsiteSearchClick = (data) => ({
    event: 'onsiteSearchClick',
    timestamp: Math.floor(Date.now() / 1000),
    content: {
        onsiteSearch: onsiteSearchData(data),
    },
    link: onsiteSearchClickData(data),
});

const defaultItem = {
    event: undefined,
};
let lastConsentUpdate = null;
const trackingFunctions = {
    defaultPageView,
    consentUpdate,
    scroll,
    pageError,
    defaultLinkClick,
    onsiteSearch,
    videoStart,
    videoComplete,
    videoProgress,
    videoError,
    formStart,
    formSuccess,
    formError,
    onsiteSearchClick,
};
const trackingBaseType = (type) => (data) => {
    const trackingFunction = trackingFunctions[type];
    if (trackingFunction) {
        return Object.assign(Object.assign(Object.assign({}, defaultItem), { event: type }), trackingFunction(data));
    }
    return Object.assign(Object.assign({}, defaultItem), { event: type });
};
const AdobeTracking = (data, type) => {
    AdobeTrackingService.push(trackingBaseType(type)(data));
};
const AdobeTrackingService = {
    push(item = defaultItem) {
        if (shouldPushConsentUpdate(item)) {
            window.oneDataLayer = window.oneDataLayer || [];
            window.oneDataLayer.push(Object.assign({}, item));
        }
    },
};
function shouldPushConsentUpdate(newItem) {
    if (newItem.event === 'consentUpdate') {
        if (lastConsentUpdate
            && JSON.stringify(lastConsentUpdate.user.consent) === JSON.stringify(newItem.user.consent)) {
            return false;
        }
        lastConsentUpdate = Object.assign({}, newItem);
    }
    return true;
}

export { AdobeTracking as A };

//# sourceMappingURL=index7.js.map